import { render, staticRenderFns } from "./cog-play-icon.vue?vue&type=template&id=4aec3bac&scoped=true"
import script from "./cog-play-icon.vue?vue&type=script&lang=js"
export * from "./cog-play-icon.vue?vue&type=script&lang=js"
import style0 from "./cog-play-icon.vue?vue&type=style&index=0&id=4aec3bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec3bac",
  null
  
)

export default component.exports